import {LitElement, html, css} from 'lit';
import {customElement, state} from 'lit/decorators.js';
import './clam-main-app.js';
import './admin/shells/clam-admin-app/clam-admin-app.js';
import './views/clam-confirmar.js';
import './components/migdrp-logo/migdrp-logo.js';
import {injectTheme} from './admin/theme/theme.js';

injectTheme();

type Shell = 'public' | 'admin' | 'confirmar';

import './admin/components/clam-session-expired/clam-session-expired.js';

function currentShell(): Shell {
    const p = window.location.pathname;
    if (p === '/admin' || p.startsWith('/admin/') || p === '/login' || p.startsWith('/login/')) return 'admin';
    if (p === '/sesion-expirada') return 'admin';
    if (p === '/confirmar' || p.startsWith('/confirmar/')) return 'confirmar';
    return 'public';
}

function getConfirmToken(): string {
    const parts = window.location.pathname.split('/');
    return parts.length >= 3 ? decodeURIComponent(parts[2]) : '';
}

@customElement('clam-root')
export class ClamRoot extends LitElement {
    static styles = css`
        :host {
            display: block;
            width: 100%;
            min-height: 100vh;
        }
    `;

    @state() private _shell: Shell = currentShell();

    connectedCallback(): void {
        super.connectedCallback();
        window.addEventListener('popstate', this._onRoute);
        document.body.classList.toggle('admin-route', this._shell === 'admin');
    }

    disconnectedCallback(): void {
        super.disconnectedCallback();
        window.removeEventListener('popstate', this._onRoute);
    }

    private _onRoute = (): void => {
        this._shell = currentShell();
        document.body.classList.toggle('admin-route', this._shell === 'admin');
    };

    render(): unknown {
        if (this._shell === 'admin') return html`<clam-admin-app></clam-admin-app>`;
        if (this._shell === 'confirmar') return html`<clam-confirmar .token=${getConfirmToken()}></clam-confirmar>`;
        return html`<clam-main-app></clam-main-app>`;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        'clam-root': ClamRoot;
    }
}
